import SideDish from '@components/offer/models/SideDish';
import { Box } from '@mui/material';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React from 'react';
import SideDishListItem from './SideDishListItem';

interface SideDishListProps {
    sideDishes: SideDish[];
    onClick: (sideDish: SideDish) => void;
}

const SideDishList: React.FC<SideDishListProps> = observer(({ sideDishes, onClick }) => {
    return (
        <Box display={"flex"} flexDirection={'column'} justifyContent={"center"} gap={0.5} mt={1}>
            {_.map(sideDishes, (sideDish) => (
                <SideDishListItem key={sideDish.id} sideDish={sideDish} onClick={onClick} />
            ))}
        </Box>
    )
})

export default SideDishList;